import "@fontsource/ibm-plex-mono/400.css"
import "@fontsource/ibm-plex-mono/400-italic.css"
import "@fontsource/ibm-plex-mono/500.css"
import "@fontsource/ibm-plex-mono/500-italic.css"
import "@fontsource/ibm-plex-mono/600.css"
import "@fontsource/ibm-plex-mono/600-italic.css"
import "@fontsource/ibm-plex-mono/700.css"
import "$styles/index.css"

import { ready } from "./ready"
import { updateMeetupButtons } from "./meetup"
import "./toggle-theme"
import "./toggle-menu"

import "lite-youtube-embed"
import "lite-youtube-embed/src/lite-yt-embed.css"

// Import all JavaScript & CSS files from src/_components
import components from "bridgetownComponents/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!", components)

ready(updateMeetupButtons)
